import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import _ from 'lodash'

import style from './workout-card.module.scss'

/**
 * Render Card of the Workout
 * @param {Number} index Index of the card on the scroller
 * @param {Object} styleEl The style created by the infinite scroller to keep the element's position
 * @param {Object} workoutImage The gatsby image
 * @param {Object} workout The workout to be displayed
 */
const WorkoutCard = ({ index, styleEl, workoutImage, workout }) => {
    const words = [
        workout.categoryTitle,
        workout.durationSeconds &&
            `${Math.ceil(workout.durationSeconds / 60)}min`,
    ].filter(it => it)

    const dotColor = _.get(workout, 'goal.color')

    return (
        <div
            style={styleEl}
            key={workout.title || index}
            className={`el-${index}`}
        >
            <div className={cn(style.workoutCardRow)}>
                <div className={style.workoutCard}>
                    <div
                        className={cn(
                            style.workoutImage,
                            'animated-background'
                        )}
                    >
                        {workoutImage ||
                            (workout.imageUrl && (
                                <img
                                    src={`${workout.imageUrl}webapp-thumbnail.jpg`}
                                    alt={workout.title}
                                />
                            ))}
                    </div>
                    <div className={style.workoutText}>
                        <span className="gym-text gym-text--medium guillon-demi">
                            {workout.title || (
                                <span className="animated-background__label animated-background" />
                            )}
                        </span>
                        <span
                            className={cn(
                                'gym-text gym-text--small guillon-demi',
                                style.workoutTextSub
                            )}
                        >
                            {words.join(', ') || (
                                <span
                                    className={cn(
                                        'animated-background__label--small',
                                        'animated-background'
                                    )}
                                />
                            )}
                        </span>
                    </div>
                    <div className={style.workoutCategories}>
                        <div
                            className={cn(
                                style.workoutCategory,
                                dotColor || 'animated-background'
                            )}
                            style={{
                                backgroundColor: `#${dotColor}`,
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

WorkoutCard.propTypes = {
    index: PropTypes.number.isRequired,
    styleEl: PropTypes.object,
    workoutImage: PropTypes.node,
    workout: PropTypes.object,
}

WorkoutCard.defaultProps = {
    styleEl: 0,
    workoutImage: null,
    workout: {},
}

export default WorkoutCard
